<template>
  <div class="login-container">
    <div class="login-box">
      <h2 class="login-title">车牌选号系统</h2>
      <a-form
        class="login-form"
        @submit="handleSubmit"
      >
        <a-form-item>
          <a-input
            v-model="username"
            placeholder="用户名"
            size="large"
          >
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            v-model="password"
            type="password"
            placeholder="密码"
            size="large"
          >
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            class="login-button"
            size="large"
            :loading="loading"
          >
            登录
          </a-button>
        </a-form-item>
        <a-form-item style="margin-bottom: 0;">
          <div class="login-footer">
            <a-button type="link" @click="goToRegister">没有账号？去注册</a-button>
          </div>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  methods: {
    async handleSubmit (e) {
      e.preventDefault()
      
      if (!this.username || !this.password) {
        this.$message.warning('请输入用户名和密码！')
        return
      }
      
      this.loading = true
      
      try {
        // 先尝试登录，获取用户信息
        const response = await api.login(this.username, this.password)
        
        if (!response.success) {
          this.$message.error(response.message || '登录失败，请检查用户名和密码')
          this.loading = false
          return
        }
        
        const user = response.user
        const sessionToken = response.session_token
        
        // 保存登录信息和session token
        this.$store.commit('setCurrentUser', user)
        this.$store.commit('setIsLoggedIn', true)
        this.$store.commit('setSessionToken', sessionToken)
        
        // 根据角色跳转
        if (user.role === 'admin') {
          this.$message.success('管理员登录成功！')
          this.$router.push('/admin')
        } else {
          this.$message.success('登录成功！')
          this.$router.push('/')
        }
      } catch (error) {
        // 登录失败
        this.$message.error(error.message || '登录失败，请检查用户名和密码')
        this.loading = false
      }
    },
    goToRegister () {
      this.$router.push('/register')
    }
  },
  mounted () {
    // 如果已经登录，直接跳转
    if (this.$store.state.isLoggedIn) {
      const currentUser = this.$store.state.currentUser
      if (currentUser && currentUser.role === 'admin') {
        this.$router.push('/admin')
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-box {
  width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.login-title {
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

.login-form {
  width: 100%;
}

.login-button {
  width: 100%;
  height: 40px;
  font-size: 16px;
}

.login-footer {
  text-align: center;
  width: 100%;
}
</style>

